// Standard library imports
import React, { useEffect, useState } from 'react';

// External library imports
import { toast } from 'react-toastify';
import moment from 'moment';
import lodashGet from 'lodash/get';
// Internal Module Imports
import Typography from '../../../../components/Typography/Typography';
import DateRangePicker from '../../../../components/Inputs/DateRangePicker/DateRangePicker';
import Table from '../../../../components/Table/Table';
import economicsClasses from '../Economics.module.css';
import { useLoader, useUserRole } from '../../../../hooks';
import { RootEconomicsService } from '../../../../services/BiddingService/Root/EconomicsService';
import { AdminEconomicsService } from '../../../../services/BiddingService/Admin/EconomicsService';
import allDeviceClasses from '../../../../styles/AllDevices.module.css';
import { usToEuCurrencyFormat } from '../../../../utils/currencyHelper';

const AREA_DIRECTIONS = ['DK1-INC', 'DK1-DEC', 'DK2-INC', 'DK2-DEC'];

const AreaEnergyRevenue = ({ data, setOpen }) => {
    const { isRootUser } = useUserRole();
    const service = isRootUser ? RootEconomicsService : AdminEconomicsService;
    const [startLoader, stopLoader] = useLoader();
    const [dateRange, setDateRange] = useState(data.dateRange);
    const [revenue, setRevenue] = useState([]);

    useEffect(() => {
        getAreaBasedRevenue();
    }, []);

    const getAreaBasedRevenue = () => {
        const params = {
            startDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
            endDate: moment(dateRange.endDate).format('YYYY-MM-DD'),
            market: data.market,
        };

        service.GetEnergyRevenue(params, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = ({ data }) => {
        const responseData = lodashGet(data, 'data', []);
        const rows = AREA_DIRECTIONS.map((id) => {
            const [area, direction] = id.split('-');
            const el = responseData.find((item) => item._id === id) || {};
            return {
                area,
                direction,
                revenue: Math.round(Number(el?.areaBasedRevenue || 0)).toLocaleString('da-DK'),
                overDelivery: usToEuCurrencyFormat(Number(el?.overDelivery || 0) / 1000),
                underDelivery: usToEuCurrencyFormat(Number(el?.underDelivery || 0) / 1000),
                requested: usToEuCurrencyFormat(Number(el?.requested || 0) / 1000),
                activated: usToEuCurrencyFormat(Number(el?.activated || 0) / 1000),
                consumption: usToEuCurrencyFormat(Number(el?.areaBasedConsumption || 0) / 1000),
            };
        });
        setRevenue(rows);
    };

    const handleError = (err) => {
        if (err && err.response) toast.error(err.response.data.message);
    };

    return (
        <div style={{ width: '65vw' }}>
            <div className={economicsClasses.AreaModalHeader}>
                <div style={{ marginTop: '1.5vh' }}>
                    <Typography content={`Energy market`} />
                </div>

                <div className={economicsClasses.AreaModalFiler}>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div className={allDeviceClasses.DateLabels} style={{ marginBottom: 0 }}>
                                Start Date
                            </div>
                            <div className={allDeviceClasses.DateLabels} style={{ marginBottom: 0 }}>
                                End Date
                            </div>
                        </div>
                        <DateRangePicker
                            startDate={dateRange.startDate}
                            endDate={dateRange.endDate}
                            onChange={(date) =>
                                setDateRange({
                                    startDate: new Date(date.startDate),
                                    endDate: new Date(date.endDate),
                                })
                            }
                        />
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '1.5vh' }}>
                <Table
                    data={revenue}
                    head={['Area', 'Direction', 'Revenue (€)', 'Over delivered (MWh)', 'Under delivered (MWh)', 'Requested (MWh)', 'Activated (MWh)', 'Consumption (MWh)']}
                    keys={['area', 'direction', 'revenue', 'overDelivery', 'underDelivery', 'requested', 'activated', 'consumption']}
                />
            </div>

            <div className={allDeviceClasses.ButtonContainer}>
                <div>
                    <button type="button" className="btn-secondary" onClick={() => setOpen({ status: false, data: null })}>
                        Cancel
                    </button>
                </div>
                <div onClick={getAreaBasedRevenue}>
                    <button className="btn-primary">Submit</button>
                </div>
            </div>
        </div>
    );
};

export default AreaEnergyRevenue;
